import { render, staticRenderFns } from "./cash-collection-restaurant-sale.vue?vue&type=template&id=537728f6"
import script from "./cash-collection-restaurant-sale.vue?vue&type=script&lang=js"
export * from "./cash-collection-restaurant-sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports